module.exports = __webpack_public_path__ + "img/intro-sec02-bg.4a52144b.png";